export const NO_RECORD_ERROR = 'NO_RECORD';
export const SAML_ERROR = 'SAML_ERROR';
export const TWO_FACTOR_NAMETAG_FAILED = 'TWO_FACTOR_NAMETAG_FAILED';
export const FETCH_LOGIN_REQUIREMENTS_GENERAL_ERROR = 'FETCH_LOGIN_REQUIREMENTS_GENERAL_ERROR';